import ProductConstants from "./ProductConstants";

export const NUMBER_REGEX = /^[0-9\b]+$/;

export const CHARACTER_REGEX = /^[a-zA-Z \b]+$/;

export const MOBILE_NO_VALIDATION = /^([6-9]{1})([0-9]{9})/

export const PAN_NUMBER_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

export const EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

export const CALCULATOR_MODAL_DESCRIPTION =
  "This tool utilizes the details like monthly expenses, outstanding loan amounts, assets, savings etc. to calculate the inflation corrected amount required to maintain your family's lifestyle and secure their future.";

export const RETIREMENT_CALCULATOR_MODAL_DESCRIPTION =
  "This tool utilizes the monthly expenses to calculate the inflation corrected amount required to maintain your lifestyle after retirement.";

export const RIDERS_DEFAULT_SA = "100000";

// Riders Description
export const ADB_RIDER_DESCRIPTION = "Gives your nominee an additional lumpsum amount in case of your death due to accident";
export const ATPD_RIDER_DESCRIPTION = "Gives you additional lumpsum amount in case of total and permanent disability due to accident";
export const CRITICAL_ILLNESS_RIDER_DESCRIPTION = "Gives you a lumpsum payout if you're diagnosed with any of the 12 critical illnesses";
export const INCOME_BENEFIT_RIDER_DESCRIPTION = "Additional monthly benefit for 150 months paid to your nominee in case of your death";
export const HOSPITALITY_CASH_BENEFIT_RIDER_DESCRIPTION = "Gives you a daily cash benefit in case of hospitalization"
export const WOP_RIDER_DESCRIPTION = "Removes the burden of paying future premiums, if you're diagnosed with any of the 12 critical illnesses or in case of accidental and total permanent disability";
export const PWB_RIDER_DESCRIPTION = "if your death happens during ppt, your life assured will not have to pay any premiums and the policy benefits will continue for them";

export const FAMILY_BENEFIT_INCOME_OPTION_RIDER = 'Policy and its benefits continue even in case of your death even after paying death benefit to nominee.'
export const RIDER_GST_PERCENT = 18;
export const PRODUCT_GST_PERCENT = 18;

export const TOKEN_EXPIRY_TIME_IN_MINUTES = 19
// Below parameter is used to make Refresh token API call every 10 minutes 600000 ms = 10 Minutes
export const REFRESH_TOKEN_IN_MINUTES = 600000

export const CUSTOMIZATION_LOADER_MSG = "Calculating"
export const SOLUTION_PREVIEW_LOADER_MSG = "Generating"

/// Modal Factor for Forward and Reverse Calculation

// for 8.8%
export const MONTHLY_MODAL_FACTOR = 0.088;
// for 26%
export const QUATERLY_MODAL_FACTOR = 0.26;
// for 51.2%
export const SEMI_ANNUAL_MODAL_FACTOR = 0.512;
// for 100%
export const ANNUAL_MODAL_FACTOR = 1;

export const SUB_STATUS_IMPENDING = "impending"
export const SUB_STATUS_IMPENDING_MSG = "Agent is Suspended. Connect with DOPS"

export const SUB_STATUS_RISK = "risk investigation"
export const SUB_STATUS_RISK_MSG = "The Agent code is under 'Risk Investigation' and hence business sourcing is restricted. Please reach Risk Team on email id Fraud prevention@edelweisslife.in for further clarification."

export const SUB_STATUS_ACTIVE = "active"

export const ULIP_TRAINING = "To source any business, mandatory trainings need to be completed. As per our records, mandatory trainings have not been completed. Please get in touch with sales training team for its completion."

export const API_DELAY_TIME = 10
export const COOKIE_PARA_NAME_FOR_JOURNEY_ID = "journeyId"
export const SAMS_JOURNEY = "SAMS"
export const BANCA_JOURNEY = "BANCA"
export const disabledProposerFieldBanca = ['salutation', 'first_name', 'middle_name', 'last_name', 'gender', 'dob'];

export const NEW_QMS_CHANNEL_LIST = ['OA', 'CBM', 'CSB', 'IM']
export const BANCA_SAMS_URL = "https://samsuat.edelweisslife.in/UI/lead/callback?dat=vGsG1rmjG95bqEXF2x7hTQ%3D%3D"
export const ACCEPT_NATIONALITY = ['NRI','Foreign National','FNIO/PIO'] 
export const ELIGIBLE_SECONDARY_LA_PRODUCT = [ProductConstants.LEGACY_PLUS_INCOME,ProductConstants.LEGACY_PLUS_LUMPSUM, ProductConstants.FLEXI_DREAM_PLAN, ProductConstants.FLEXI_GOAL_SECURE]
